<template>
    <h1 class="text-h4 mb-1">{{ titleHeading }}</h1>

    <div class="app-catalog__filter">
        <v-row 
            no-gutters
        >
            <v-col 
                sm="12"
                md="8"
            >
                <v-row
                    class="justify-space-between align-center"
                    no-gutters
                >
                    <v-col 
                        sm="8"
                        md="8"
                        class="pr-2"
                    >
                        <v-text-field
                            v-model="filter.search"
                            clearable
                            label="Поиск"
                            prepend-icon="fa fa-search"
                            variant="outlined"
                            density="compact"
                            hide-details
                            clear-icon="fa fa-close"
                            :loading="loadingFilter ? 'indigo-darken-3' : false"
                            @keyup="setFilter(true)"
                            @click:clear="setFilter"
                        ></v-text-field>
                    </v-col>
                    <v-col 
                        sm="4"
                        md="2"
                        class="pr-2"
                    >
                        <v-select
                            v-model="filter.searchType"
                            label="Поиск по"
                            :items="searchTypeItems"
                            item-title="name"
                            item-value="value"
                            variant="outlined"
                            hide-details
                            density="compact"
                            menu-icon="fa fa-angle-down"
                            :disabled="loadingFilter"
                        ></v-select>
                    </v-col>
                </v-row>
            </v-col>
            

            <v-col 
                sm="12"
                md="4"
            >
                <v-row
                    class="justify-end align-center"
                    no-gutters
                >
                    <v-col 
                        sm="12"
                        md="2"
                    >
                        <v-select
                            v-model="limitSet"
                            label="На стр."
                            :items="limitItems"
                            variant="outlined"
                            hide-details
                            density="compact"
                            menu-icon="fa fa-angle-down"
                            :disabled="loadingFilter"
                            @update:modelValue="setFilter"
                        ></v-select>
                    </v-col>
                    <!-- <v-col 
                        sm="12"
                        md="6"
                        class="text-right"
                    >
                        <v-btn
                            color="success"
                            :to="{name: 'user_add'}"
                        >
                            <template v-slot:prepend>
                                <v-icon size="14">fa fa-plus</v-icon>
                            </template>
                            Добавить пользователя
                        </v-btn>
                    </v-col> -->
                </v-row>
            </v-col>
        </v-row>
    </div>

    <v-skeleton-loader
        :loading="preLoading"
        type="table-row@5"
        class="w-100"
    >
        <div class="app-catalog__category">
        
            <div class="app-catalog__category-list title user">
                <div>#</div>
                <div>ФИО</div>
                <div>Телефон</div>
                <div>E-mail</div>
                <div>Создан</div>
                <div>Обновлен</div>
                <div>Действия</div>
            </div>

            <div
                class="app-catalog__category-list user"
                v-for="(item, key) in dataItems"
                :key="key"
            >
                <div class="col">{{ item.id }}</div>
                <div class="col">
                    {{ item.name }}
                </div>
                <div class="col">
                    {{ item.phone }}
                </div>
                <div class="col">
                    {{ item.email }}
                </div>
                <div class="col">{{ item.created }}</div>
                <div class="col">{{ item.updated }}</div>
                <div class="col">
                    <v-btn
                        :to="{ name: 'user_edit', params: { id: item.id }}"
                        @click="setTitle(item.name)"
                        size="small"
                        icon
                        variant="plain"
                    >
                        <v-icon size="14">fa fa-cog</v-icon>
                    </v-btn>

                    <v-btn
                        color="red"
                        size="small"
                        icon
                        variant="plain"
                        @click="remove(key, item)"
                    >
                        <v-icon size="14">fa fa-trash</v-icon>
                    </v-btn>
                </div>

                <div
                    v-if="loadingItem[key]"
                    class="loading"
                >
                    <v-progress-circular
                        color="indigo-darken-3"
                        indeterminate
                    ></v-progress-circular>
                </div>

            </div>

            <div v-if="!dataItems.length" class="d-flex text-center w-100 pa-2 justify-center align-center">
                Нет данных
            </div>
        

            <div v-if="pageTotal > 1" class="text-center pt-1 pb-1">
                <v-pagination
                    v-model="page"
                    :length="pageTotal"
                    :total-visible="7"
                    density="compact"
                    prev-icon="fas fa-chevron-left"
                    next-icon="fas fa-chevron-right"
                ></v-pagination>
            </div>
        </div>
    </v-skeleton-loader>

    <RemovePopup
        :data="removeData"
        :open="openRemove"
        :title="titleRemove"
        :body="bodyRemove"
        @close="closeRemove"
        @action="removeItem"
        :loading="loadingRemove" />
</template>
<script>
import RemovePopup from '@/components/popus/RemovePopup'

export default {
    name: 'UserListPage',
    components: {
        RemovePopup
    },
    data: () => ({
        page: 1,
        title: '',
        loading: false,
        items: [],
        limitItems: [10, 20, 50, 100],
        offset: 0,
        limitSet: 20,
        total: 0,
        searchTypeItems: [
            {
                'value': 'id',
                'name': 'ID'
            },
            {
                'value': 'name',
                'name': 'ФИО'
            }
        ],
        loadingFilter: false,
        filter: {
            searchType: 'name',
            search: '',
            status: null
        },
        timerSearch: null,

        loadingItem: {},

        openRemove: false,
        removeData: {},
        loadingRemove: false,
        titleRemove: '',
        bodyRemove: ''
    }),
    mounted () {
    },
    watch: {
        $route: {
            handler(to) {

                if(!to.params.id) this.title = ''
                else this.filter.search = ''

                this.$store.commit('Update', {
                    key: 'preloader',
                    value: true
                })

                this.init()
            }
        },
        page() {
            
            this.offset = ((this.limit * this.page) - this.limit)

            this.$store.commit('Update', {
                key: 'preloader',
                value: true
            })

            this.get()
        }
    },
    methods: {
        init() {
            this.items = []
            this.offset = 0

            this.get()
        },
        get() {
            this.loading = true

            let filter = {}

            if(this.filter.search) {
                filter.search = this.filter.search
                filter.type = this.filter.searchType
            }

            this.$store.dispatch('API', {
                method: 'GET',
                url: '/user',
                params: {
                    'limit': this.limit,
                    'offset': this.offset,
                    'filter': filter
                }
            }).then(res => {

                if(res.data.status === 'success') {

                    if(res.data.data.title) this.setTitle(res.data.data.title)

                    this.total = res.data.data.total

                    this.items = res.data.data.items
                }

                this.loading = false
                this.loadingFilter = false

                this.$store.commit('Update', {
                    key: 'preloader',
                    value: false
                })
            })
        },
        setTitle(title = '') {
            if(title) {
                this.$store.commit('Update', {
                    key: 'titlePage',
                    value: title
                })

                this.title = title
            }
        },
        setFilter(input=false) {

            this.$store.commit('Update', {
                key: 'itemsLimit',
                value: this.limitSet
            })

            clearTimeout(this.timerSearch)

            this.$store.commit('Update', {
                key: 'preloader',
                value: true
            })

            if(input) {

                this.timerSearch = setTimeout(() => {
                    this.loadingFilter = true

                    this.init()

                    this.timerSearch = null
                }, 500)

            }else{
                this.init()
                this.loadingFilter = false
            }
        },
        remove(i, item) {

            this.removeData = {
                key: i,
                item: item
            }

            this.openRemove = true
            this.titleRemove = 'Удалить пользователя #' + item.id
            this.bodyRemove = 'Вы уверены, что хотите удалить пользователя <b>' + item.name + '</b>?'

        },
        closeRemove() {
            this.openRemove = false

        },
        removeItem(data) {

            this.loadingRemove = true
            this.loadingItem[data.key] = true

            this.$store.dispatch('API', {
                method: 'POST',
                url: '/user/' + data.item.id + '/remove',
            }).then(res => {

                if(res.data.status === 'success') {
                    delete this.items[data.key]
                }

                delete this.loadingItem[data.key]

                this.loadingRemove = false
                this.openRemove = false

                this.get()
            })
        }
    },
    computed: {
        titleHeading() {
            return this.title || this.$route.meta.title
        },
        dataItems() {

            let items = []

            this.items.forEach(item => {

                item.created = this.$moment(item.created_at).calendar(null, {
                    sameDay: '[Сегодня], HH:mm:ss',
                    nextDay: '[Завтра], HH:mm:ss',
                    nextWeek: 'DD.MM.YYYY HH:mm:ss',
                    lastDay: 'DD.MM.YYYY HH:mm:ss',
                    lastWeek: 'DD.MM.YYYY HH:mm:ss',
                    sameElse: 'DD.MM.YYYY HH:mm:ss'
                })

                item.updated = this.$moment(item.updated_at).calendar(null, {
                    sameDay: '[Сегодня], HH:mm:ss',
                    nextDay: '[Завтра], HH:mm:ss',
                    nextWeek: 'DD.MM.YYYY HH:mm:ss',
                    lastDay: 'DD.MM.YYYY HH:mm:ss',
                    lastWeek: 'DD.MM.YYYY HH:mm:ss',
                    sameElse: 'DD.MM.YYYY HH:mm:ss'
                })

                items.push(item)
            })

            return items
        },
        preLoading() {
            return this.$store.state.preloader
        },
        preloaderGlobal() {
            return this.$store.state.preloaderGlobal
        },
        pageTotal() {

            if(!this.total) return 0

            return Math.ceil(this.total/this.limit)
        },
        limit() {
            return this.$store.state.itemsLimit
        }
    },
    created() {

        this.limitSet = this.limit

        this.$store.commit('Update', {
            key: 'preloader',
            value: true
        })
        this.init()        
    },
    unmounted() {
        
    }
}
</script>